module.exports = __webpack_public_path__ + "static/media/Uninettuno.af067048.png";